import { useSelector, useDispatch } from 'react-redux';
import { useIsMobile } from '@agro1desenvolvimento/react-hooks';
import { selectSidebarActive, toggleActive } from './sidebarSlice';
import Logo from './Logo/Logo';
import MainMenu from './MainMenu/MainMenu';
import './Sidebar.scss';

const Sidebar = () => {
  const isExpanded = useSelector(selectSidebarActive);
  const isMobile = useIsMobile();
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(toggleActive());
  };

  const handleOverlayClick = () => {
    if (isMobile && isExpanded) {
      dispatch(toggleActive());
    }
  };

  return (
    <>
      {isMobile && isExpanded && (
        <button className="sidebar-overlay" onClick={handleOverlayClick} />
      )}

      <div className={`sidebar ${isExpanded ? 'sidebar--expanded' : 'sidebar--collapsed'}`}>
        <div className="sidebar__header">
          {isExpanded && <Logo />}
          <button
            className="sidebar__toggle"
            onClick={handleToggle}
            type="button"
          >
            <i className="pi pi-bars" />
          </button>
        </div>
        <MainMenu />
      </div>
    </>
  );
};

export default Sidebar;
